<template>
<article class="brand-resource sub-content">
  <div class="brand-resource__wrap">
    <h1 class="brand-resource__title">
      {{$t('brand.title')}}
    </h1>
    <section class="section section--ci">
      <h1 class="section__title">CI</h1>
      <div class="section__body">
        <h2>{{$t('brand.ci.title')}}</h2>
        <p>{{$t('brand.ci.description')}}</p>
        <nav>
          <CustomButton link="#" @click.prevent="onClickDownload">
            {{$t('brand.download.ai')}}
          </CustomButton>
          <CustomButton link="#" @click.prevent="onClickDownload">
            {{$t('brand.download.pdf')}}
          </CustomButton>
        </nav>
      </div>
    </section>
    <section class="section section--bi">
      <h1 class="section__title">BI</h1>
      <div class="section__body">
        <div class="service">
          <h2>{{$t('brand.bi.section1Title')}}</h2>
          <p>{{$t('brand.bi.section1Description')}}</p>
          <nav>
            <CustomButton link="#" @click.prevent="onClickDownload">
              {{$t('brand.download.ai')}}
            </CustomButton>
          </nav>
        </div>
        <div class="service">
          <h2>{{$t('brand.bi.section2Title')}}</h2>
          <p>{{$t('brand.bi.section2Description')}}</p>
          <nav>
            <CustomButton link="#" @click.prevent="onClickDownload">
              {{$t('brand.download.korean')}}
            </CustomButton>
            <CustomButton link="#" @click.prevent="onClickDownload">
              {{$t('brand.download.english')}}
            </CustomButton>
          </nav>
        </div>
      </div>
    </section>
  </div>
</article>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import CustomButton from '~/components/pages/brand-resource/custom-button.vue'

const { t } = useI18n()

definePageMeta({
  middleware: 'service',
})

function onClickDownload()
{
  alert(t('base.comingSoon'))
}
</script>

<style src="./index.scss" lang="scss" scoped></style>
